export enum BENEFICIARY_TYPE {
	NOMINATED = 'NON BINDING',
	REVERSIONARY = 'REVERSIONARY',
	BINDING = 'BINDING',
	NON_LAPSING_BINDING = 'NON-LAPSING BINDING',
}

export const TRUSTEE_DETERMINED = 'TrusteeDetermined';
